import React, { useMemo } from 'react'
import ScrollToTop from 'react-scroll-up'
import { detect } from 'detect-browser'
import cn from 'classnames'

import { Header } from './Header'
import { Footer } from './Footer'
import { ThemeProvider, ThemeVariant } from './theme'

import logoImage from 'App/Resources/images/logo/logo_AG_out-01_canvas.png'
import { ScrollToTopIcon } from './components/ScrollToTopIcon'

export type LayoutProps = {
  //
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const browser = useMemo(detect, [])

  return (
    <ThemeProvider defaultThemeVariant={ThemeVariant.DARK}>
      <div id="gen-wrap" style={{ overflowX: 'clip' }}>
        <div
          id="wrap"
          className={cn({
            [`browser-${browser?.name}`]: browser?.name,
          })}
        >
          <Header logoImage={logoImage} />
          <div className="page-content-wrap">
            {children}
            <Footer logoImage={logoImage} />
          </div>
        </div>
        <ScrollToTop showUnder={160} duration={250} style={{ zIndex: 999 }}>
          <ScrollToTopIcon />
        </ScrollToTop>
      </div>
    </ThemeProvider>
  )
}
